// extracted by mini-css-extract-plugin
export default {"formLabel":"formLabel__dqfck","plantNameField":"plantNameField__G9day","changePlantBtn":"changePlantBtn__1SlHi"};